import { Children, PropsWithChildren, ReactNode } from 'react';

import { Spacing } from 'theme/theme';
import { interleave } from 'utils/functional/array';

import { StackHolder } from './Stack.styled';

type Props = {
  divider?: ReactNode;
  direction?: 'row' | 'column';
  spacing?: Spacing;
  'data-qa-id'?: string;
};

export function Stack({
  children,
  divider,
  direction = 'column',
  spacing,
  'data-qa-id': qaId,
}: PropsWithChildren<Props>) {
  return (
    <StackHolder data-qa-id={qaId} $direction={direction} $spacing={spacing}>
      {divider ? interleave(Children.toArray(children), divider) : children}
    </StackHolder>
  );
}
